export default "__VITE_ASSET__rP2NvqQO__"